<template>
    <div @click="modal.recover = false"
        class="fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center bg-black/50">
        <div @click.stop class="px-10 py-5 relative flex flex-col w-[500px] bg-white rounded-md mx-2">
            <div @click="modal.recover = false" class="absolute cursor-pointer right-2 top-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" class="w-6 h-6">
                    <path fill-rule="evenodd"
                        d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                        clip-rule="evenodd" />
                </svg>
            </div>
            <div class="flex flex-col w-full gap-y-4">
                <h2 class="text-xl font-bold text-[#5A2800]">Recuperar Senha</h2>
                <TextInput placeholder="email@gmail.com" v-model:input="email" inputType="email" />
                <button @click="submit" :disabled="isLoading"
                    class="rounded-full w-full p-3 font-bold"
                    :class="email ? 'bg-[#5A2800] hover:bg-[#7A3800] text-white' : 'bg-gray-300 text-gray-500'">
                    {{ isLoading ? 'Enviando...' : 'Enviar' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useModalStore } from '~/stores/modal'
import { useAlert } from '~/stores/alert'
import axios from "~/plugins/axios"

const modal = useModalStore()
const { showAlert } = useAlert()
const $axios = axios().provide.axios

let email = ref('')
let isLoading = ref(false)

async function submit() {
    if (!email.value) return
    
    try {
        isLoading.value = true
        const { data } = await $axios.post('/api/auth/password/email', { email: email.value })
        
        showAlert('success', 'Email de recuperação enviado!')
        modal.recover = false
        email.value = ''
    } catch (err) {
        showAlert('error', err.response?.data?.message || 'Erro ao enviar email')
    } finally {
        isLoading.value = false
    }
}
</script>
